import { render, staticRenderFns } from "./password_reminder.vue?vue&type=template&id=8fee04ee&scoped=true&"
import script from "./password_reminder.vue?vue&type=script&lang=js&"
export * from "./password_reminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fee04ee",
  null
  
)

export default component.exports